import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      copyLinkButton: this.el.querySelector('.masthead-common-content__modal-copy-btn'),
      copyUrl: this.el.querySelector('.masthead-common-content__modal-copy-url'),
      copyFeedback: this.el.querySelector('.masthead-common-content__modal-copy-feedback'),
      shareModal: this.el.querySelector('#share-masthead-common-modal'),
      shareBtn: this.el._$('.masthead-common-content__share-btn')
    };

    this.updateCopyUrl();
  }

  addListeners() {
    if (this.dom.shareBtn){
      this.dom.copyLinkButton.addEventListener('click', this.handleCopyLink.bind(this));
      this.dom.shareModal.addEventListener('modalclose', () => this.dom.copyFeedback.innerHTML='');
      this.dom.shareBtn._on('click', this.handleCopyLink.bind(this));
    }
  }

  handleCopyLink(e) {
    e.preventDefault();
    this.dom.copyUrl.focus();
    this.dom.copyUrl.select();
    document.execCommand('copy');
    this.dom.copyFeedback.innerHTML = '<p>Link copied to clipboard!</p>';
  }

  updateCopyUrl() {
    if (this.dom.copyUrl){
      const url = window.location.href
      this.dom.copyUrl.value = url.toString();
    }
  }
}

export default Module;
